// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wKyS","col":"styles_col__2H7G2"};